import React from 'react';
import Button from '@kyruus/button';
import { injectIntl, FormattedMessage } from '@kyruus/intl';

import messages from './messages';

import {
  AvailabilityControlsContainer,
  ButtonsContainer,
  StyledChip,
  SelectedAppointmentContainer,
  AvailabilityControlsHeadingOff,
  AvailabilityControlsHeadingOn,
  FlexContainer
} from './styles';
import { NEW_PATIENT } from '../../utils/constants';

const AvailabilityControls = ({
  selectedAppointment,
  handleToggle,
  handleEdit,
  intl
}) => {
  const isOn = Boolean(selectedAppointment);

  const buttons = [];

  if (isOn) {
    const editBtn = (
      <Button
        key="edit"
        mode="ghost"
        onClick={handleEdit}
        data-testid="AvailabilityControls--edit"
        aria-label={intl.formatMessage(
          messages.editGlobalAvailabilityBtnTextAriaLabel
        )}
      >
        <FormattedMessage {...messages.editGlobalAvailabilityBtnText} />
      </Button>
    );

    const offBtn = (
      <Button
        key="off"
        mode="secondary"
        onClick={handleToggle}
        data-testid="AvailabilityControls--toggle"
        aria-label={intl.formatMessage(
          messages.hideGlobalAvailabilityBtnTextAriaLabel
        )}
      >
        <FormattedMessage {...messages.hideGlobalAvailabilityBtnText} />
      </Button>
    );

    buttons.push(editBtn, offBtn);
  }

  if (!isOn) {
    const onBtn = (
      <Button
        key="on"
        mode="ghost"
        onClick={handleToggle}
        data-testid="AvailabilityControls--toggle"
        aria-label={intl.formatMessage(
          messages.showGlobalAvailabilityBtnTextAriaLabel
        )}
      >
        <FormattedMessage {...messages.showGlobalAvailabilityBtnText} />
      </Button>
    );

    buttons.push(onBtn);
  }

  return (
    <AvailabilityControlsContainer isOn={isOn}>
      {isOn ? (
        <>
          <AvailabilityControlsHeadingOn>
            <FormattedMessage {...messages.globalAvailControlsHeaderTextOn} />
          </AvailabilityControlsHeadingOn>
          <FlexContainer>
            <SelectedAppointmentContainer>
              <StyledChip
                label={
                  selectedAppointment.patientRel === NEW_PATIENT ? (
                    <FormattedMessage {...messages.patientRelBtnTextNew} />
                  ) : (
                    <FormattedMessage
                      {...messages.patientRelBtnTextEstablished}
                    />
                  )
                }
                data-testid="AvailabilityControls--patientRel"
              />
              <StyledChip
                label={selectedAppointment.purpose}
                data-testid="AvailabilityControls--apptPurpose"
              />
            </SelectedAppointmentContainer>
            <ButtonsContainer>{buttons}</ButtonsContainer>
          </FlexContainer>
        </>
      ) : (
        <ButtonsContainer>{buttons}</ButtonsContainer>
      )}

      {!isOn ? (
        <AvailabilityControlsHeadingOff>
          <FormattedMessage {...messages.globalAvailControlsHeaderTextOff} />
        </AvailabilityControlsHeadingOff>
      ) : null}
    </AvailabilityControlsContainer>
  );
};

export default injectIntl(AvailabilityControls);
